<template>
  <div class="auth-wrapper">
    <div class="auth-panel">
      <div class="logo-holder d-flex align-items-center justify-content-between">
        <div class="title">Forgot password</div>
        <img src="/images/logo-dark.svg" alt="">
      </div>
      <div class="form-holder">
          <!--        <form action="">-->
          <div class="auth-instr">
            <p>{{$static('login.instr', 'Для відновлення пароля перейдіть в білінг-панель, і натисніть три крапки')}}</p>
            <img src="/images/forgot.png" alt="">
          </div>

          <div class="button-holder">
            <button class="default-btn btn-accent" @click="goToPage">
              <span class="text">{{$static('login.forgot', 'Відновити')}}</span>
            </button>
          </div>
          <!--        </form>-->


      </div>
    </div>
    <div class="blur-box">
      <div class="back-link">
        <a href="https://t.me/uxwebbot">
          <span class="icon icon-left"></span>
          <span class="link-text">{{$static('login.back', 'Повернутись назад')}}</span>
        </a>
      </div>
      <h1 v-html="$static('login.attent1', 'Доступ до админ панелі можливий лише з компьютеру у повній web-версії сайту.')" ></h1>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import axios from '@/api';

  export default {
    name      : 'AdminLogin',
    components: {},
    data() {
      return {
        // login   : 'uxlove',
        // password: 'adminpass'
      }
    },
    methods   : {
      sendLoginApiCall() {
        return axios.post('/auth/login', {login: this.login, password: this.password}).then(() => {
          this.$router.push({name: 'Dashboard'})
        })
      },
      goToPage(){
        window.location.replace("https://ux.im/app");
      }
    }
  }
</script>

<style scoped>
  .blur-box {
    position   : absolute;
    width      : 100%;
    height     : 100%;
    z-index    : 1111111;
    background : rgba(247, 247, 247, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
  @media (min-width: 800px) {
    .blur-box{
      display: none;
    }
  }

</style>